'use client';

import React from 'react';
import { Modal } from '@/app/components/ui/Modal';
import { Button } from '@/app/components/ui/Button';

interface ExitConfirmationModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirmExit: () => void;
    onSave: () => void;
    title?: string;
    description?: string;
    primaryCta?: string;
    secondaryCta?: string;
    primaryAction?: 'confirm' | 'save';
    secondaryAction?: 'confirm' | 'close';
    isLoading?: boolean;
}

export const ExitConfirmationModal = ({
    isOpen,
    onClose,
    onConfirmExit,
    onSave,
    title = "Are you Sure?",
    description = "",
    primaryCta = "Save Progress",
    secondaryCta = "Leave Without Saving",
    primaryAction = 'save',
    secondaryAction = 'confirm',
    isLoading = false,
}: ExitConfirmationModalProps) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose} title={title}>
            <div className="space-y-6">
                {description && (
                    <p className="text-base text-foreground leading-relaxed">
                        {description}
                    </p>
                )}

                <div className="flex flex-col-reverse sm:flex-row gap-3 sm:justify-end">
                    <Button
                        variant="primary"
                        onClick={primaryAction === 'confirm' ? onConfirmExit : onSave}
                        disabled={isLoading}
                    >
                        {isLoading ? 'Processing...' : primaryCta}
                    </Button>
                    <Button
                        variant="ghost"
                        onClick={secondaryAction === 'close' ? onClose : onConfirmExit}
                        disabled={isLoading}
                        className="text-destructive hover:text-destructive hover:bg-destructive/10"
                    >
                        {secondaryCta}
                    </Button>
                </div>
            </div>
        </Modal>
    );
};
